import { SideNavItem } from '../../types';

export const useFilterProductLinks = () => {
	return function filterProductLinks(_navItem: SideNavItem) {
		return true;
	};
};
